import client from 'api/client';

const t = () => `/${Date.now()}`;

// ============================================================================
// Notificaciones del usuario en sesión (db/041)
//
// Dos caminos que se complementan:
//   - este servicio las TRAE guardadas (lo que pasó mientras no estabas)
//   - el hook useNotifications escucha Reverb y agrega las que llegan en vivo
//
// Guardadas y transmitidas: el WebSocket solo adelanta el aviso.
// ============================================================================

export interface Notification {
  keyNotification: string;
  /** flight.flown | flight.uploaded | assignment.new … */
  type: string;
  title: string;
  message: string | null;
  /** Ruta del backoffice a la que lleva el clic. */
  url: string | null;
  icon: string | null;
  actorName: string | null;
  read: boolean;
  readAt: string | null;
  dateCreate: string;
}

export interface NotificationList {
  items: Notification[];
  unread: number;
}

export const notificationService = {
  list: (onlyUnread = false): Promise<NotificationList> =>
    client.post(`/notifications${t()}`, { onlyUnread }).then((r) => r.data.data),

  markRead: (key: string): Promise<void> =>
    client.post(`/notifications/${key}/read${t()}`).then((r) => r.data),

  markAllRead: (): Promise<void> =>
    client.post(`/notifications/read-all${t()}`).then((r) => r.data),
};
